import { Product } from "../productsData";

function getAllHalfSleeveRegularTShirtsData(): Product[] {
  return [
    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: " Half Sleeve Regular T-Shirts",
          path: "/half-sleeve-regular-tshirts-for-men",
        },
      ],
      pathName: "ife-is-unstoppable",
      fullPath:
        "/half-sleeve-regular-tshirts-for-men/product/ife-is-unstoppable",
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662439510/shopping%20cart/half%20sleeve%20regular/mthrsr74-black-920x920_he5nud.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663298769/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr74-biscuit-920x920_km9s2g.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663298762/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr74-Deep-ash-1-920x920_nssezt.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663298756/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr74-ardoise-920x920_rczoex.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662464167/shopping%20cart/half%20sleeve%20regular/product%20card%20images/mthrsr74-black-350x435_y7ndbw.jpg",
      name: "Life Is Unstoppable",
      price: "৳ 320.00",
      details: [
        "Regular fit, Crew Neck, Comfortable to wear",
        "170 GSM",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
      ],
      fabric: ["CARD COTTON", "VISCOSE COTTON", "COMBED COTTON"],
      color: ["Black", "Biscuit", "Deep Ash", "Ardoise"],
      size: ["S", "M", "L", "XL", "XXL"],
      description: [
        "S(Small): Chest 37.79″ inch/ 96 cm, Height 26.77″inch/ 68 cm",
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "CARD COTTON, VISCOSE COTTON, COMBED COTTON",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: " Half Sleeve Regular T-Shirts",
          path: "/half-sleeve-regular-tshirts-for-men",
        },
      ],
      pathName: "train-insane",
      fullPath: "/half-sleeve-regular-tshirts-for-men/product/train-insane",
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662439762/shopping%20cart/half%20sleeve%20regular/mthrsr75-black-920x920_x9kdqr.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663298880/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr75-turkish-blue-920x920_gicv9v.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663298871/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr75-royal-blue-920x920_tm0zxc.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663298865/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr75-navy-920x920_kur0lv.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662464244/shopping%20cart/half%20sleeve%20regular/product%20card%20images/mthrsr75-anthra-350x435_ota22m.jpg",
      name: "Train Insane",
      price: "৳ 320.00",
      details: [
        "Regular fit, Crew Neck, Comfortable to wear",
        "170 GSM",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
      ],
      fabric: ["CARD COTTON", "VISCOSE COTTON", "COMBED COTTON"],
      color: ["Black", "Turkish Blue", "Royal Blue", "Navy"],
      size: ["S", "M", "L", "XL", "XXL"],
      description: [
        "S(Small): Chest 37.79″ inch/ 96 cm, Height 26.77″inch/ 68 cm",
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "CARD COTTON, VISCOSE COTTON, COMBED COTTON",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: " Half Sleeve Regular T-Shirts",
          path: "/half-sleeve-regular-tshirts-for-men",
        },
      ],
      pathName: "success-story",
      fullPath: "/half-sleeve-regular-tshirts-for-men/product/success-story",
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662439869/shopping%20cart/half%20sleeve%20regular/mthrsr73-black-920x920_gcsqsh.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663298978/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr73-ardoise-920x920_nyfju5.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663298970/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr73-black-920x920_tcjxxl.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663298963/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr73-anthra-920x920_bkbvb0.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662464294/shopping%20cart/half%20sleeve%20regular/product%20card%20images/mthrsr73-black-350x435_vny1ip.jpg",
      name: "Success Story",
      price: "৳ 320.00",
      details: [
        "Regular fit, Crew Neck, Comfortable to wear",
        "170 GSM",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
      ],
      fabric: ["CARD COTTON", "VISCOSE COTTON", "COMBED COTTON"],
      color: ["Black", "Ardoise", "Black", "Anthra"],
      size: ["S", "M", "L", "XL", "XXL"],
      description: [
        "S(Small): Chest 37.79″ inch/ 96 cm, Height 26.77″inch/ 68 cm",
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "CARD COTTON, VISCOSE COTTON, COMBED COTTON",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: " Half Sleeve Regular T-Shirts",
          path: "/half-sleeve-regular-tshirts-for-men",
        },
      ],
      pathName: "thcr72-over-load",
      fullPath: "/half-sleeve-regular-tshirts-for-men/product/thcr72-over-load",
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662439968/shopping%20cart/half%20sleeve%20regular/mthrsr72-anthra-920x920_tyordu.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663303609/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr72-black-920x920_pybc7m.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663303603/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/MTHRSR72-Bottle-Green_mt9cco.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663303600/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr72-ardoise-920x920_zfjqpw.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662464332/shopping%20cart/half%20sleeve%20regular/product%20card%20images/mthrsr72-anthra-350x435_uv7cio.jpg",
      name: "Over Load",
      price: "৳ 320.00",
      details: [
        "Regular fit, Crew Neck, Comfortable to wear",
        "170 GSM",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
      ],
      fabric: ["CARD COTTON", "VISCOSE COTTON", "COMBED COTTON"],
      color: ["Anthra", "Black", "Bottle Green", "Ardoise"],
      size: ["S", "M", "L", "XL", "XXL"],
      description: [
        "S(Small): Chest 37.79″ inch/ 96 cm, Height 26.77″inch/ 68 cm",
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "CARD COTTON, VISCOSE COTTON, COMBED COTTON",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: " Half Sleeve Regular T-Shirts",
          path: "/half-sleeve-regular-tshirts-for-men",
        },
      ],
      pathName: "thcr71-dont-follow-the-trend",
      fullPath:
        "/half-sleeve-regular-tshirts-for-men/product/thcr71-dont-follow-the-trend",
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662440070/shopping%20cart/half%20sleeve%20regular/mthrsr71-black-920x920_qupl5z.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663303701/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr71-anthra-920x920_u38ttu.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663303696/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr71-ardoise-920x920_x2h9kj.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663303690/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr71-biscuit-920x920_v0xnwv.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662464371/shopping%20cart/half%20sleeve%20regular/product%20card%20images/mthrsr71-black-350x435_cdhajw.jpg",
      name: "Don’t follow the trend",
      price: "৳ 320.00",
      details: [
        "Regular fit, Crew Neck, Comfortable to wear",
        "170 GSM",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
      ],
      fabric: ["CARD COTTON", "VISCOSE COTTON", "COMBED COTTON"],
      color: ["Black", "Anthra", "Ardoise", "Biscuit"],
      size: ["S", "M", "L", "XL", "XXL"],
      description: [
        "S(Small): Chest 37.79″ inch/ 96 cm, Height 26.77″inch/ 68 cm",
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "CARD COTTON, VISCOSE COTTON, COMBED COTTON",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: " Half Sleeve Regular T-Shirts",
          path: "/half-sleeve-regular-tshirts-for-men",
        },
      ],
      pathName: "thcr70-always-have-an-attitude",
      fullPath:
        "/half-sleeve-regular-tshirts-for-men/product/thcr70-always-have-an-attitude",
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662440174/shopping%20cart/half%20sleeve%20regular/mthrsr70-black-920x920_tcoqkb.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663303783/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr70-anthra-920x920_ns6ibo.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663303777/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr70-ardoise-920x920_cme6sj.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663303773/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/70-Maroon-920x920_nbtczj.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662464413/shopping%20cart/half%20sleeve%20regular/product%20card%20images/mthrsr70-black-350x435_k1jghp.jpg",
      name: "Always Have An Attitude",
      price: "৳ 320.00",
      details: [
        "Regular fit, Crew Neck, Comfortable to wear",
        "170 GSM",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
      ],
      fabric: ["CARD COTTON", "VISCOSE COTTON", "COMBED COTTON"],
      color: ["Black", "Anthra", "Ardoise", "Maroon"],
      size: ["S", "M", "L", "XL", "XXL"],
      description: [
        "S(Small): Chest 37.79″ inch/ 96 cm, Height 26.77″inch/ 68 cm",
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "CARD COTTON, VISCOSE COTTON, COMBED COTTON",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: " Half Sleeve Regular T-Shirts",
          path: "/half-sleeve-regular-tshirts-for-men",
        },
      ],
      pathName: "thcr69-relax",
      fullPath: "/half-sleeve-regular-tshirts-for-men/product/thcr69-relax",
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662440282/shopping%20cart/half%20sleeve%20regular/69-Bottle-Green-920x920_illto9.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663303862/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr69-ardoise-920x920_eu5who.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663303857/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr69-anthra-920x920_ugbbl8.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663303851/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr69-royal-blue-920x920_cgcryt.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662464458/shopping%20cart/half%20sleeve%20regular/product%20card%20images/69-Bottle-Green-350x435_fisgl4.jpg",
      name: "Relax",
      price: "৳ 320.00",
      details: [
        "Regular fit, Crew Neck, Comfortable to wear",
        "170 GSM",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
      ],
      fabric: ["CARD COTTON", "VISCOSE COTTON", "COMBED COTTON"],
      color: ["Bottle Green", "Ardoise", "Anthra", "Royal Blue"],
      size: ["S", "M", "L", "XL", "XXL"],
      description: [
        "S(Small): Chest 37.79″ inch/ 96 cm, Height 26.77″inch/ 68 cm",
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "CARD COTTON, VISCOSE COTTON, COMBED COTTON",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: " Half Sleeve Regular T-Shirts",
          path: "/half-sleeve-regular-tshirts-for-men",
        },
      ],
      pathName: "thcr68-moonlight",
      fullPath: "/half-sleeve-regular-tshirts-for-men/product/thcr68-moonlight",
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662440366/shopping%20cart/half%20sleeve%20regular/mthrsr68-black-920x920_kvfgf8.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663303938/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr68-black-920x920_ab0wir.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663303933/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr68-ardoise-920x920_u3uun9.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663303929/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/68-Maroon-920x920_isqf4l.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662464500/shopping%20cart/half%20sleeve%20regular/product%20card%20images/mthrsr68-black-350x435_dq3lj8.jpg",
      name: "Moonlight",
      price: "৳ 320.00",
      details: [
        "Regular fit, Crew Neck, Comfortable to wear",
        "170 GSM",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
      ],
      fabric: ["CARD COTTON", "VISCOSE COTTON", "COMBED COTTON"],
      color: ["Black", "Ardoise", "Maroon"],
      size: ["S", "M", "L", "XL", "XXL"],
      description: [
        "S(Small): Chest 37.79″ inch/ 96 cm, Height 26.77″inch/ 68 cm",
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "CARD COTTON, VISCOSE COTTON, COMBED COTTON",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: " Half Sleeve Regular T-Shirts",
          path: "/half-sleeve-regular-tshirts-for-men",
        },
      ],
      pathName: "thcr67-the-worst-distance",
      fullPath:
        "/half-sleeve-regular-tshirts-for-men/product/thcr67-the-worst-distance",
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662440472/shopping%20cart/half%20sleeve%20regular/mthrsr67-black-920x920_upvroy.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663304033/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/67-Biscuit-920x920_mlxbos.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663304027/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/67-Bottle-Green-920x920_tgtwox.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663304021/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/67-Maroon-920x920_o1tmqo.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662464564/shopping%20cart/half%20sleeve%20regular/product%20card%20images/mthrsr67-black-350x435_i6ffek.jpg",
      name: "The Worst Distance",
      price: "৳ 320.00",
      details: [
        "Regular fit, Crew Neck, Comfortable to wear",
        "170 GSM",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
      ],
      fabric: ["CARD COTTON", "VISCOSE COTTON", "COMBED COTTON"],
      color: ["Black", "Biscuit", "Bottle Green", "Maroon"],
      size: ["S", "M", "L", "XL", "XXL"],
      description: [
        "S(Small): Chest 37.79″ inch/ 96 cm, Height 26.77″inch/ 68 cm",
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "CARD COTTON, VISCOSE COTTON, COMBED COTTON",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: " Half Sleeve Regular T-Shirts",
          path: "/half-sleeve-regular-tshirts-for-men",
        },
      ],
      pathName: "r66-dont-quit",
      fullPath: "/half-sleeve-regular-tshirts-for-men/product/r66-dont-quit",
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662440558/shopping%20cart/half%20sleeve%20regular/mthrsr66-black-920x920_oifm7d.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663304107/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr66-ardoise-920x920_eixcbf.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663304103/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr66-black-920x920_vxp6c5.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663304097/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/66-Maroon-920x920_ayjlmt.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662464626/shopping%20cart/half%20sleeve%20regular/product%20card%20images/mthrsr66-black-350x435_nudtdi.jpg",
      name: "Don’t Quit",
      price: "৳ 320.00",
      details: [
        "Regular fit, Crew Neck, Comfortable to wear",
        "170 GSM",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
      ],
      fabric: ["CARD COTTON", "VISCOSE COTTON", "COMBED COTTON"],
      color: ["Black", "Ardoise", "Maroon"],
      size: ["S", "M", "L", "XL", "XXL"],
      description: [
        "S(Small): Chest 37.79″ inch/ 96 cm, Height 26.77″inch/ 68 cm",
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "CARD COTTON, VISCOSE COTTON, COMBED COTTON",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: " Half Sleeve Regular T-Shirts",
          path: "/half-sleeve-regular-tshirts-for-men",
        },
      ],
      pathName: "r65-action-speaks-louder-than-words",
      fullPath:
        "/half-sleeve-regular-tshirts-for-men/product/r65-action-speaks-louder-than-words",
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662440736/shopping%20cart/half%20sleeve%20regular/mthrsr65-black-920x920_uuurat.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663304256/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr65-black-920x920_zddzjt.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663304252/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr65-ardoise-920x920_ks7kc4.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663304246/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/65-Bottle-Green-920x920_tbx8vv.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662464689/shopping%20cart/half%20sleeve%20regular/product%20card%20images/mthrsr65-black-350x435_iwoypz.jpg",
      name: "Action Speaks Louder Than Words",
      price: "৳ 320.00",
      details: [
        "Regular fit, Crew Neck, Comfortable to wear",
        "170 GSM",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
      ],
      fabric: ["CARD COTTON", "VISCOSE COTTON", "COMBED COTTON"],
      color: ["Black", "Ardoise", "Bottle Green"],
      size: ["S", "M", "L", "XL", "XXL"],
      description: [
        "S(Small): Chest 37.79″ inch/ 96 cm, Height 26.77″inch/ 68 cm",
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "CARD COTTON, VISCOSE COTTON, COMBED COTTON",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: " Half Sleeve Regular T-Shirts",
          path: "/half-sleeve-regular-tshirts-for-men",
        },
      ],
      pathName: "r64-be-kind",
      fullPath: "/half-sleeve-regular-tshirts-for-men/product/r64-be-kind",
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662463116/shopping%20cart/half%20sleeve%20regular/mthrsr64-black-920x920_hcttrp.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663304337/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr64-ardoise-920x920_xn1ugf.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663304332/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/64-Maroon-920x920_fnfidh.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662463116/shopping%20cart/half%20sleeve%20regular/mthrsr64-black-920x920_hcttrp.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662464774/shopping%20cart/half%20sleeve%20regular/product%20card%20images/mthrsr64-black-350x435_oju0ea.jpg",
      name: "Be Kind",
      price: "৳ 320.00",
      details: [
        "Regular fit, Crew Neck, Comfortable to wear",
        "170 GSM",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
      ],
      fabric: ["CARD COTTON", "VISCOSE COTTON", "COMBED COTTON"],
      color: ["Black", "Ardoise", "Maroon"],
      size: ["S", "M", "L", "XL", "XXL"],
      description: [
        "S(Small): Chest 37.79″ inch/ 96 cm, Height 26.77″inch/ 68 cm",
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "CARD COTTON, VISCOSE COTTON, COMBED COTTON",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: " Half Sleeve Regular T-Shirts",
          path: "/half-sleeve-regular-tshirts-for-men",
        },
      ],
      pathName: "r63-one-day-im-gonna-make-the-onions-cry",
      fullPath:
        "/half-sleeve-regular-tshirts-for-men/product/r63-one-day-im-gonna-make-the-onions-cry",
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662463249/shopping%20cart/half%20sleeve%20regular/mthrsr63-black-920x920_nhrkll.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663304512/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr63-ardoise-920x920_ep50rp.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663304508/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/63-Bottle-Green-920x920_omge1i.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663304504/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/63-Anthra-920x920_ywimdp.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662464824/shopping%20cart/half%20sleeve%20regular/product%20card%20images/mthrsr63-black-350x435_lzoqao.jpg",
      name: "One Day I’m Gonna make the Onions Cry",
      price: "৳ 320.00",
      details: [
        "Regular fit, Crew Neck, Comfortable to wear",
        "170 GSM",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
      ],
      fabric: ["CARD COTTON", "VISCOSE COTTON", "COMBED COTTON"],
      color: ["Black", "Ardoise", "Bottle Green", "Anthra"],
      size: ["S", "M", "L", "XL", "XXL"],
      description: [
        "S(Small): Chest 37.79″ inch/ 96 cm, Height 26.77″inch/ 68 cm",
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "CARD COTTON, VISCOSE COTTON, COMBED COTTON",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: " Half Sleeve Regular T-Shirts",
          path: "/half-sleeve-regular-tshirts-for-men",
        },
      ],
      pathName: "r62-dare-to-be-different",
      fullPath:
        "/half-sleeve-regular-tshirts-for-men/product/r62-dare-to-be-different",
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662463363/shopping%20cart/half%20sleeve%20regular/mthrsr62-black-920x920_zuxqtu.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663304600/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr62-royal-blue-1-920x920_dy8tk2.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663304596/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr62-ardoise-920x920_wa0lfh.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663304586/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr62-anthra-920x920_uejg2b.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662465126/shopping%20cart/half%20sleeve%20regular/product%20card%20images/mthrsr62-black-350x435_itnpha.jpg",
      name: "Dare to be Different",
      price: "৳ 320.00",
      details: [
        "Regular fit, Crew Neck, Comfortable to wear",
        "170 GSM",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
      ],
      fabric: ["CARD COTTON", "VISCOSE COTTON", "COMBED COTTON"],
      color: ["Black", "Royal Blue", "Ardoise", "Anthra"],
      size: ["S", "M", "L", "XL", "XXL"],
      description: [
        "S(Small): Chest 37.79″ inch/ 96 cm, Height 26.77″inch/ 68 cm",
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "CARD COTTON, VISCOSE COTTON, COMBED COTTON",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: " Half Sleeve Regular T-Shirts",
          path: "/half-sleeve-regular-tshirts-for-men",
        },
      ],
      pathName: "r58-take-a-hike",
      fullPath: "/half-sleeve-regular-tshirts-for-men/product/r58-take-a-hike",
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662463462/shopping%20cart/half%20sleeve%20regular/mthrsr58-black-920x920_ld5370.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663304688/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr58-ardoise-920x920_v0zq1n.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663304683/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr58-black-920x920_cxbtss.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663304677/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/58-Bottle-Green-920x920_dgngh4.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662464972/shopping%20cart/half%20sleeve%20regular/product%20card%20images/mthrsr58-black-350x435_n9vjra.jpg",
      name: "Take a Hike",
      price: "৳ 320.00",
      details: [
        "Regular fit, Crew Neck, Comfortable to wear",
        "170 GSM",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
      ],
      fabric: ["CARD COTTON", "VISCOSE COTTON", "COMBED COTTON"],
      color: ["Black", "Ardoise", "Bottle Green"],
      size: ["S", "M", "L", "XL", "XXL"],
      description: [
        "S(Small): Chest 37.79″ inch/ 96 cm, Height 26.77″inch/ 68 cm",
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "CARD COTTON, VISCOSE COTTON, COMBED COTTON",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: " Half Sleeve Regular T-Shirts",
          path: "/half-sleeve-regular-tshirts-for-men",
        },
      ],
      pathName: "r29-sohurey",
      fullPath: "/half-sleeve-regular-tshirts-for-men/product/r29-sohurey",
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662463599/shopping%20cart/half%20sleeve%20regular/mthrsr29-black-920x920_oaqtoz.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663304841/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr29-ardoise-920x920_avxt2v.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663304835/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/29-Maroon-920x920_npslhr.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663304841/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsr29-ardoise-920x920_avxt2v.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662465058/shopping%20cart/half%20sleeve%20regular/product%20card%20images/mthrsr29-black-350x435_jfjgxt.jpg",
      name: "Sohurey",
      price: "৳ 320.00",
      details: [
        "Regular fit, Crew Neck, Comfortable to wear",
        "170 GSM",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
      ],
      fabric: ["CARD COTTON", "VISCOSE COTTON", "COMBED COTTON"],
      color: ["Black", "Ardoise", "Maroon"],
      size: ["S", "M", "L", "XL", "XXL"],
      description: [
        "S(Small): Chest 37.79″ inch/ 96 cm, Height 26.77″inch/ 68 cm",
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "CARD COTTON, VISCOSE COTTON, COMBED COTTON",
        size: "S, M, L, XL, XXL",
      },
    },
  ];
}

export default getAllHalfSleeveRegularTShirtsData;

function getSpecificHalfSleeveRegularTShirtData(searchPath: string) {
  return (
    getAllHalfSleeveRegularTShirtsData().find((product) => {
      const productPath = product.pathName;
      return productPath === searchPath;
    }) || getAllHalfSleeveRegularTShirtsData()[0]
  );
}

export { getSpecificHalfSleeveRegularTShirtData };
